'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { toast } from 'sonner';
import { CheckCircle, Share2, Heart, Award, Clock, BookOpen, Users, Zap, Lock } from 'lucide-react';

export default function CourseEnrollCard() {
  const [enrolled, setEnrolled] = useState(false);
  const [wishlisted, setWishlisted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleEnroll = async () => {
    // Courses are locked — redirect to sign up to enroll
    window.location.href = '/sign-up-login-screen';
  };

  return (
    <div className="card overflow-hidden shadow-card-hover">
      {/* Preview thumbnail */}
      <div className="relative h-44">
        <img
          src="https://img.rocket.new/generatedImages/rocket_gen_img_13be4626e-1772082100332.png"
          alt="Neural network visualization preview for Machine Learning Fundamentals course"
          className="w-full h-full object-cover" />
        
        <div className="absolute inset-0 bg-foreground/30 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full bg-card/90 flex items-center justify-center cursor-pointer hover:bg-card transition-colors">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="var(--primary)">
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
        <span className="absolute bottom-2 left-2 text-xs font-bold bg-card text-primary px-2 py-0.5 rounded-full">
          Preview available
        </span>
      </div>
      <div className="p-5 space-y-4">
        {/* Price */}
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-extrabold text-success">Free</span>
          <span className="text-sm text-muted-foreground line-through">$49.99</span>
          <span className="text-xs font-bold bg-danger/10 text-danger px-2 py-0.5 rounded-full">100% off</span>
        </div>

        {/* Enroll CTA */}
        {enrolled ?
        <Link href="/lesson-player" className="btn-primary w-full py-3 flex items-center justify-center gap-2">
            <Zap size={16} />
            Continue Learning
          </Link> :

        <button
          onClick={handleEnroll}
          disabled={loading}
          className="btn-primary w-full py-3 btn-press flex items-center justify-center gap-2">
            <Lock size={15} />
            Enrol Free — Sign Up Required
          </button>
        }

        {enrolled &&
        <div className="flex items-center gap-2 text-sm text-success bg-success/10 rounded-xl p-3">
            <CheckCircle size={16} />
            <span className="font-medium">You&apos;re enrolled! Progress is saved automatically.</span>
          </div>
        }

        {/* Wishlist + Share */}
        <div className="flex gap-2">
          <button
            onClick={() => {setWishlisted(!wishlisted);toast(wishlisted ? 'Removed from wishlist' : 'Added to wishlist');}}
            className="btn-outline flex-1 py-2 text-sm">
            
            <Heart size={14} className={wishlisted ? 'fill-danger text-danger' : ''} />
            {wishlisted ? 'Wishlisted' : 'Wishlist'}
          </button>
          <button className="btn-outline px-3 py-2" aria-label="Share course">
            <Share2 size={14} />
          </button>
        </div>

        {/* Includes */}
        <div className="border-t border-border pt-4 space-y-2.5">
          <p className="text-xs font-semibold text-foreground uppercase tracking-wide">This course includes</p>
          {[
          { icon: <Clock size={13} />, text: '12h 30m on-demand video' },
          { icon: <BookOpen size={13} />, text: '18 lessons + 2 quizzes' },
          { icon: <Award size={13} />, text: 'Certificate of completion' },
          { icon: <Users size={13} />, text: 'Community forum access' },
          { icon: <CheckCircle size={13} />, text: 'Lifetime access' }]?.
          map((item, i) =>
          <div key={`include-card-${i}`} className="flex items-center gap-2.5 text-sm text-muted-foreground">
              <span className="text-primary">{item?.icon}</span>
              {item?.text}
            </div>
          )}
        </div>

        {/* Guarantee */}
        <p className="text-xs text-center text-muted-foreground">
          30-day satisfaction guarantee · No credit card required
        </p>
      </div>
    </div>);

}